/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBalloon: {
  name: 'balloon';
  data: string;
} = {
  name: 'balloon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5c0 .033.002.066.005.099A5.002 5.002 0 0 0 7 10v7a5 5 0 0 0 10 0v-7c0-2.42-1.72-4.44-4.005-4.901.003-.033.005-.066.005-.099V4h1a1 1 0 1 0 0-2h-4a1 1 0 0 0 0 2h1v1ZM9 17h2a1 1 0 1 0 0-2H9v-3h2a1 1 0 1 0 0-2H9a3 3 0 1 1 6 0v7a3 3 0 1 1-6 0Z" fill="currentColor"/></svg>`,
};
